import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IPartner } from 'clickNgo/entities/partner/models'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IForm } from 'core-components/classes/models/IForm'
import { IFilter } from 'core-components/types'
import { Logic, Operator } from 'core-components/types'
import { IDataProviderFilter } from 'core-components/types/ICrudHelpers'
import { CrudStore } from 'core/types/crudStore'

import { mapPartnerFromPartnerAllDataRegions } from './mapping'

interface IFetchPartnerHierarchy {
  partnerId: string
  page?: number
  pageSize?: number
  withoutInactive?: boolean
  withoutSelf?: boolean
}

export const fetchPartnerHierarchy = (
  { partnerId, page = 0, pageSize = 10000, withoutSelf, withoutInactive }: IFetchPartnerHierarchy,
  options?: ICrudFetchOptions
): Promise<IPartner[]> => {
  const crud = CrudStore.get(
    CrudStoreItem.PartnerAllData,
    options?.cacheKey || `partnerHierarchy-${partnerId}`
  )
  const filterByTopPartnerId = {
    field: 'TopPartnerID',
    operator: Operator.EQUAL,
    value: partnerId,
  }
  const filterByActiveStatus = {
    logic: Logic.OR,
    filters: [
      {
        field: 'StatusExt',
        operator: Operator.EQUAL,
        value: 'Active',
      },
      {
        field: 'StatusExt',
        operator: Operator.ISNULL,
        value: '',
      },
    ],
  }
  const filterByNotSelf = {
    field: 'PartnerID',
    operator: Operator.NOTEQUAL,
    value: partnerId,
  }
  const initialFilters: Array<IDataProviderFilter | IFilter> = [filterByTopPartnerId]

  if (withoutInactive) {
    initialFilters.push(filterByActiveStatus)
  }

  if (withoutSelf) {
    initialFilters.push(filterByNotSelf)
  }

  const filters = {
    logic: Logic.AND,
    filters: initialFilters,
  }
  const paging = { page, pageSize }

  crud.setFilter(filters)
  crud.setPaging(paging)

  return crud.fetch().then((result: { items: IForm[] }) => {
    if (result && result.items && result.items.length) {
      return result.items.map((item) => mapPartnerFromPartnerAllDataRegions(item))
    }

    return []
  })
}
